<template>
  <v-card>
    <v-card-title class="text-center ">
      <v-row no-gutters justify="center" class="PatuaFontClean text-uppercase font-weight-black text-h4">
        Quotation
      </v-row>
    </v-card-title>
    <v-row no-gutters justify="center" class="text-uppercase font-weight-black text-h6">
      Booking No: {{ invoice.booking_txt_id }}
    </v-row>
    <v-row style="font-size: 18px" no-gutters justify="center" class="text-uppercase font-weight-black">
      Quotation ID: {{ invoice.quotation_txt_id }}
    </v-row>
    <v-card-text>
      Your booking has been submitted. Our team will contact you soon.
    </v-card-text>
    <v-container class="pa-4">
      <v-row class="mb-4" justify="start" no-gutters>
        <h4 class="font-weight-black ThemeFont">Your Details</h4>
      </v-row>

      <v-row no-gutters align="end" justify="space-between">
        <v-col cols="12" sm="12" md="7" lg="7" xl="7">
          <h6 class="font-weight-medium text-start mb-n2">Name</h6>
          <h6 class="font-weight-black text-start ">{{ invoice['customer_name'] }}</h6>
        </v-col>

        <v-col cols="12" sm="12" md="5" lg="5" xl="5">
          <h6 class="font-weight-medium text-start mb-n2">NIC</h6>
          <h6 class="font-weight-bold text-start">{{ invoice['customer_nic'] }}</h6>
        </v-col>
      </v-row>

      <v-row no-gutters justify="space-between">
        <v-col cols="7">
          <h6 class="font-weight-medium text-start mb-n2">Email</h6>
          <h6 style="word-break: break-word !important;" class="font-weight-bold text-start">{{ invoice['customer_email'] }}</h6>
        </v-col>

        <v-col cols="5" >
          <h6 class="font-weight-medium text-start mb-n2">Address</h6>
          <h6 class="font-weight-bold text-start">{{ invoice['customer_address'] }}</h6>
        </v-col>
      </v-row>

      <v-row no-gutters justify="space-between">
        <v-col cols="7">
          <h6 class="font-weight-medium text-start mb-n2">Phone</h6>
          <h6 style="word-break: break-word !important;" class="font-weight-bold text-start">{{ invoice['customer_phone_no'] }}</h6>
        </v-col>

        <v-col cols="5" >
          <h6 class="font-weight-medium text-start mb-n2">Additional Phone</h6>
          <h6 class="font-weight-bold text-start">{{ invoice['customer_additional_phone_no'] }}</h6>
        </v-col>
      </v-row>
    </v-container>
    <v-divider/>
    <v-container class="pa-4">
      <v-row class="mb-4" justify="start" no-gutters>
        <h4 class="font-weight-black ThemeFont">Our Details</h4>
      </v-row>

      <v-row no-gutters align="end" justify="space-between">
        <v-col cols="12" sm="12" md="7" lg="7" xl="7">
          <h6 class="font-weight-medium text-start mb-n2">Company</h6>
          <h6 class="font-weight-black text-start ">Wild Ceylon Adventures Pvt Ltd</h6>
        </v-col>

        <v-col cols="12" sm="12" md="5" lg="5" xl="5">
          <h6 class="font-weight-medium text-start mb-n2">Email</h6>
          <h6 class="font-weight-bold text-start">info@wildceylonadventures.com</h6>
        </v-col>
      </v-row>

      <v-row no-gutters justify="space-between">
        <v-col cols="7">
          <h6 class="font-weight-medium text-start mb-n2">Address</h6>
          <h6 style="word-break: break-word !important;" class="font-weight-bold text-start">145/1, Highlevel Road, Pannipitiya, Sri Lanka</h6>
        </v-col>

        <v-col cols="5" >
          <h6 class="font-weight-medium text-start mb-n2">Phone</h6>
          <h6 class="font-weight-bold text-start">0715 808 080</h6>
        </v-col>
      </v-row>
    </v-container>
    <v-divider/>
    <v-container class="pa-4">
      <v-row class="mb-4" justify="start" no-gutters>
        <h4 class="font-weight-black ThemeFont">Booking Details</h4>
      </v-row>

      <v-row no-gutters align="end" justify="space-between">
        <v-col cols="7">
          <h6 class="font-weight-medium text-start mb-n2">Park Name</h6>
          <h6 class="font-weight-black text-start ">{{ park.name }}</h6>
        </v-col>

        <v-col cols="5" >
          <h6 class="font-weight-medium text-start mb-n2">No. of Guests</h6>
          <h6 class="font-weight-bold text-start">{{ people }}</h6>
        </v-col>
      </v-row>

      <v-row no-gutters justify="space-between">
        <v-col cols="7">
          <h6 class="font-weight-medium text-start mb-n2">Check-In Date</h6>
          <h6 class="font-weight-bold text-start">{{ days[0] }}</h6>
        </v-col>

        <v-col cols="5" >
          <h6 class="font-weight-medium text-start mb-n2">Check-Out Date</h6>
          <h6 class="font-weight-bold text-start">{{ days[1] }}</h6>
        </v-col>
      </v-row>
    </v-container>
    <v-divider/>
    <v-container class="pa-4">

      <v-row justify="start" no-gutters>
        <h4 class="font-weight-black ThemeFont">Package Details</h4>
      </v-row>

      <v-row no-gutters justify="start" class="mb-0 mt-4">
        <v-col cols="auto" class="text-start">
          <span style="word-break: break-word" class="font-weight-black text-start">{{ pkg.name }}</span>
        </v-col>
        <v-col cols="auto" class="text-start">
          <span class="font-weight-bold text-h6">&nbsp;&nbsp;({{ MoneyFormat(pkg.package_details[0].price) }})
            <span class="font-weight-regular text-h6">Per Person</span>
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters justify="space-between">
        <v-col cols="auto" class="text-start">
          <span class="">{{ people }} People</span>
        </v-col>
        <v-col cols="auto" class="text-start">
          <span class="font-weight-black">{{ MoneyFormat(pkg.package_details[0].price * DDF * people) }}</span>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-divider/>
      </v-row>


      <v-row class="mb-0" justify="start" no-gutters>
        <h4 class="font-weight-black ThemeFont">Add-ons</h4>
      </v-row>
      <v-card-text class="pa-0 ma-0">
        <p style="word-break: break-word;text-align: start">
          Your addons prices will be added later.
        </p>
      </v-card-text>

      <v-row no-gutters justify="space-between">
        <v-col cols="12" class="text-start" v-for="(addon,i) in addons" :key="i">
          <span style="word-break: break-word" class="MedFont font-weight-medium text-h7 text-start">{{ addon.name }}</span>
        </v-col>

        <!--<v-col cols="12" xl="4" lg="4" md="4"  class="text-start">
          <span v-if="addon.type === 0" class="font-weight-bold">{{ MoneyFormat(addon.price) }}</span>
          <span v-if="addon.type === 0">X {{ people }}</span>
          <span v-if="addon.type !== 0" class="font-weight-bold">{{ MoneyFormat(addon.price) }}</span>
        </v-col>

        <v-col cols="4" class="text-end">
          <span v-if="addon.type === 0" class="font-weight-black text-start">{{ MoneyFormat(addon.price * people) }}</span>
          <span  v-if="addon.type !== 0" class="font-weight-black text-start">{{ MoneyFormat(addon.price) }}</span>
        </v-col>-->
      </v-row>

    </v-container>

  </v-card>
</template>

<script>
export default {
  name: "InvoiceCard",
  props:{
    pkg: Object,
    addons: Array,
    park: Object,
    people: Number,
    days: Array,
    invoice: Object
  },
  computed:{
    DDF: function(){
      let cIn = new Date(this.days[0]);
      let cOut = new Date(this.days[1]);

      return (cOut.getTime() - cIn.getTime()) / (1000 * 60 * 60 * 24);
    }
  },
  methods:{
    MoneyFormat: function(num){
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'LKR' }).format(num);
    }
  }
}
</script>

<style scoped>
.v-card {
  border: 2px solid #85BBC4 !important
}
.PatuaFontClean{
  font-family: 'Patua One',serif !important;
  color: #07614D;
}
.SelectedMoneyColor{
  color: #D6AF44;
}
.SmallFont{
  font-size: 14px;
}
.MoneyColor{
  color: #1A4F57;
}
</style>
